import React, { useEffect, useState } from "react";
import { Routes } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { routes } from "../../constants/routes";
import FormVideoSop from "./FormVideoSop";

const Video = (props) => {
  const navigate = useNavigate();
  const role = localStorage.getItem("userRole");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  let paginatedData = [];
  try {
    if (Array.isArray(filteredData)) {
      paginatedData = filteredData.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }
  useEffect(() => {
    getVideoSession();
  }, []);
  const getVideoSession = async () => {
    try {
      const response = await props.admin.getAllVideoSession();
      props.application.setLoading(true);
      if (response.success) {
        setFilteredData(response.data.video_sessions);
        props.application.setLoading(false);
      } else {
        toast.error("Failed to fetch data", {
          position: toast.POSITION.TOP_CENTER,
        });
        props.application.setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
      console.error("Error occured :", error);
    }
  };
  const handleDeleteVideoSession = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteVideoSession(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getVideoSession();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.success("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };
  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };
  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>Video Mangement</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.DASHBOARD}>Home</Link>
            </li>
            <li className="breadcrumb-item active">Video Mangement</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="d-flex justify-content-between">
                    <div>
                      <a
                        href="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#largeModal"
                      >
                        Create Video
                      </a>
                    </div>
                  </div>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {role === "admin" && <th>User Name</th>}
                            <th>Title</th>
                            <th>Company Name</th>
                            <th>Job Profile</th>
                            <th>Department</th>
                            <th>Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData && paginatedData.length > 0 ? (
                            paginatedData.map((item) => (
                              <tr key={item.id}>
                                {role === "admin" && <td>{item.user_name}</td>}
                                <td>{item.title}</td>
                                <td>{item.company_name}</td>
                                <td>{item.job_profile}</td>
                                <td>{item.department}</td>
                                <td>{item.created_at}</td>
                                <td>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() =>
                                      handleDeleteVideoSession(item.id)
                                    }
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm m-0"
                                    title="Update Session"
                                    onClick={() => {
                                      navigate(Routes.CREATE_VIDEO_Sop, {
                                        state: item.id,
                                      });
                                    }}
                                  >
                                    <i className="fa-solid fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No results found!
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {
                        <div className="table-footer">
                          <strong>Total Count: {filteredData.length}</strong>
                          {renderPagination()}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FormVideoSop />
    </main>
  );
};
export default injectModels(["admin", "application"])(Video);
